import React from 'react';
import { useRef, useEffect } from 'react';
import { useGetLastOraclePrice } from '../context/PredictionsContext';

const TradingView = () => {
  const containerRef = useRef(null);
  const tvWidgetRef = useRef(null);
  const lastOraclePrice = useGetLastOraclePrice();

  useEffect(() => {
    if (containerRef.current && window.TradingView) {
      const symbol = 'BINANCE:BTCUSDT';
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      const widgetOptions = {
        symbol,
        width: '100%',
        height: '100%',
        interval: '5',
        timezone: 'Etc/UTC',
        theme: 'dark',
        style: '1',
        locale: 'en',
        toolbar_bg: '#000000',
        enable_publishing: false,
        hide_top_toolbar: isMobile,
        hide_legend: false,
        save_image: false,
        container_id: containerRef.current.id,
        backgroundColor: '#000000',
        gridColor: '#2a2a2a',
      };

      tvWidgetRef.current = new window.TradingView.widget(widgetOptions);
      
      return () => {
        // Improved cleanup to prevent the error
        try {
          if (tvWidgetRef.current) {
            // Check if element still exists in DOM before removal
            const el = document.getElementById(containerRef.current?.id);
            if (el && el.parentNode && tvWidgetRef.current.remove) {
              tvWidgetRef.current.remove();
            }
          }
        } catch (err) {
          console.log('TradingView cleanup error:', err);
        }
      };
    }
    
    // If TradingView script is not loaded, try again in 1 second
    const timer = setTimeout(() => {
      if (!window.TradingView) {
        console.log('TradingView is not available, trying again...');
      }
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="h-full w-full bg-black">
      <div 
        id="tradingview_widget_container" 
        ref={containerRef} 
        className="h-full w-full"
      />
      {lastOraclePrice && (
        <div className="absolute top-2 left-2 bg-[#1a1a1a] px-3 py-1 rounded-md border border-[#7900ff]/30 z-10">
          <span className="text-sm text-gray-400">Oracle price:</span>
          <span className="ml-2 font-medium">${lastOraclePrice}</span>
        </div>
      )}
    </div>
  );
};

export default TradingView;